import { useStore } from '../state/store';

/**
 * トーストは画面上のどのオーバーレイより手前に出す。
 * success の半透明アクセントはゲーム画面の上でほぼ読めないので、不透明な面にする。
 */
const TONE_CLASS = {
  info: 'border-slate-500 bg-slate-900 text-slate-50',
  success: 'border-emerald-400/80 bg-emerald-950 text-emerald-50',
  error: 'border-red-400/80 bg-red-950 text-red-50',
} as const;

export function Toasts() {
  const toasts = useStore((s) => s.toasts);
  const dismiss = useStore((s) => s.dismissToast);

  if (toasts.length === 0) return null;

  return (
    <div
      className="top-safe-hud pointer-events-none fixed inset-x-0 z-[200] flex flex-col items-center gap-2 px-4"
      role="status"
      aria-live="polite"
    >
      {toasts.map((t) => (
        <button
          key={t.id}
          type="button"
          onClick={() => dismiss(t.id)}
          className={`animate-fade-in pointer-events-auto max-w-md rounded-xl border-2 px-4 py-3 text-sm font-medium shadow-[0_8px_32px_rgba(0,0,0,0.65)] ${TONE_CLASS[t.tone]}`}
        >
          {t.message}
        </button>
      ))}
    </div>
  );
}
